// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  text-transform: capitalize;
}

.header-btn {
  display: flex;
  justify-content: flex-end;
}
.header-btn .bsg-close-button {
  background: transparent;
}
.header-btn ion-icon {
  width: 19px;
}

.wrapper {
  color: var(--menu-modal-text-color);
  padding: 30px 15px 15px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.separator {
  width: 100%;
  margin: 16px 0;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
  color: var(--ion-color-secondary);
}

ion-row, button {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  margin-top: 12px;
  font-size: 26px;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.email {
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
  color: var(--ion-color-secondary);
  padding-bottom: 15px;
  border-bottom: 1px solid #D9D9D9;
}

a, button {
  text-decoration: none;
  color: black;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  font-size: 20px;
  color: var(--ion-color-secondary);
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-lang div.selected span {
  color: white;
}

.footer-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-block .lang-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer-block .lang-block .lang-item {
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  box-shadow: 0px 3.09px 11.57px 0px rgba(79, 97, 79, 0.1490196078);
  margin-right: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  background: white;
}
.footer-block .lang-block .lang-item ion-icon {
  width: 18px;
  height: 18px;
  padding: 0px;
}
.footer-block .lang-block .lang-item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-primary);
  margin-top: 5px;
  transition: color 0.3s ease;
}
.footer-block .lang-block .lang-item.selected {
  background: var(--ion-color-primary);
}
.footer-block .lang-block .lang-item.selected h3 {
  color: white;
}
.footer-block .logout {
  zoom: 1.5;
  margin: 0px;
}

.bsg-menu-nav, .bsg-legal-nav {
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
}
.bsg-menu-nav button, .bsg-legal-nav button {
  background: transparent;
}

.bsg-menu-item {
  display: flex;
  align-items: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss"],"names":[],"mappings":"AACA;EAEE,kBAAA;EACA,0BAAA;AADF;;AAGA;EACE,aAAA;EACA,yBAAA;AAAF;AACE;EACE,uBAAA;AACJ;AACE;EACE,WAAA;AACJ;;AAKA;EACE,mCAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,WAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,oCAAA;AAFF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,iCAAA;EACA,oBAAA;EACA,gCAAA;AADF;;AAIA;EACE,qBAAA;EACA,YAAA;AADF;;AAKA;EACE,YAAA;EACA,sCAAA;EACA,kCAAA;UAAA,0BAAA;AAFF;;AAIA;EACE,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AADF;;AAGA;EACE,eAAA;EACA,iCAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAEF;AAAE;EACE,iBAAA;AAEJ;AAAE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAEJ;AADM;EACE,yBAAA;EACA,0BAAA;EACA,+BAAA;AAGR;AACM;EAIE,oCAAA;EACA,YAAA;AAFR;AAFQ;EACE,YAAA;AAIV;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AACE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AACJ;AAAI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iEAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;EAMA,iBAAA;AAHN;AAFM;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAIR;AADM;EACE,oCAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,2BAAA;AAGR;AACM;EACE,oCAAA;AACR;AAAQ;EACE,YAAA;AAEV;AAIE;EACE,SAAA;EACA,WAAA;AAFJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AAFF;AAGE;EACE,uBAAA;AADJ;;AAIA;EACE,aAAA;EACA,mBAAA;AADF","sourcesContent":["@import \"../../../theme/mixins\";\napp-menu-modal {\n\n  position: relative;\n  text-transform: capitalize;\n}\n.header-btn {\n  display: flex;\n  justify-content: flex-end;\n  .bsg-close-button {\n    background: transparent;\n  }\n  ion-icon {\n    width: 19px;\n    // right: 5px ;\n    // top: 10px;\n    // position: absolute;\n  }\n}\n.wrapper {\n  color: var(--menu-modal-text-color);\n  padding: 30px 15px 15px 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.separator {\n  width: 100%;\n  margin: 16px 0;\n}\n\nion-icon {\n  width: 32px;\n  margin-right: 3px;\n  padding: 4px;\n  border-radius: 0;\n}\n\n.version {\n  opacity: 0.3;\n  font-size: x-small;\n  color: var(--ion-color-secondary);\n}\n\nion-row, button {\n  align-items: center;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.name {\n  margin: 0px;\n  margin-top: 12px;\n  font-size: 26px;\n  text-transform: uppercase;\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold, sans-serif;\n}\n.email{\n  margin: 0px;\n  font-size: 14px;\n  margin-top: 2px;\n  font-family: AppFont, sans-serif;\n  color: var(--ion-color-secondary);\n  padding-bottom: 15px;\n  border-bottom: 1px solid #D9D9D9;\n}\n\na, button {\n  text-decoration: none;\n  color: black;\n}\n\n\nion-button {\n  color: white;\n  --background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(4px);;\n}\n.lang-row{\n  font-size: 20px;\n  font-family: AppFont, sans-serif;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\nion-col {\n  font-size: 20px;\n  color: var(--ion-color-secondary);\n}\n\n.selected{\n  opacity: 1 !important;\n}\n.lang-title{\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0px;\n}\nion-icon {\n  zoom: 1.1;\n}\n\nion-row{\n  margin-top: 6px;\n}\n.header-wrap{\n  margin: 10px;\n}\n\n\n.selected{\n  opacity: 1 !important;\n}\n\n.version {\n  position: absolute;\n  bottom: 3px;\n  right: 10px;\n}\n\n.footer-lang{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  \n  div:first-child {\n    margin-left: 20px;\n  }\n  div {\n    margin: 0px 5px;\n    text-align: center;\n    width: 48%;\n    --border-color: var(--ion-color-primary);\n    border: 2px solid  var(--ion-color-primary);\n    background: transparent;\n    border-radius: 50px;\n    overflow: hidden;\n    padding: 12px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n      span {\n        text-transform: uppercase;\n        font-size: 14px !important;\n        color:  var(--ion-color-primary);\n      }\n    }\n    div {\n      &.selected {\n        span {\n          color: white;\n        }\n        background:  var(--ion-color-primary);\n        border: none;\n      }\n    }\n}\n.footer-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .lang-block {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    .lang-item {\n      padding: 8px 15px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 16px;\n      box-shadow: 0px 3.09px 11.57px 0px #4F614F26;\n      margin-right: 10px;\n      transition: background-color 0.3s ease; \n      cursor: pointer;\n      ion-icon {\n        width: 18px;\n        height: 18px;\n        padding: 0px;\n      }\n      background: white;\n      h3 {\n        font-family: AppFontBold, sans-serif;\n        font-size: 16px;\n        color: var(--ion-color-primary);\n        margin-top: 5px;\n        transition: color 0.3s ease; \n\n      }\n\n      &.selected {\n        background: var(--ion-color-primary);\n        h3 {\n          color: white;\n        }\n      }\n\n    }\n  }\n  .logout {\n    zoom: 1.5;\n    margin: 0px;\n  }\n}\n.bsg-menu-nav,.bsg-legal-nav {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  align-items: flex-start;\n  justify-content: flex-start;\n  button {\n    background: transparent;\n  }\n}\n.bsg-menu-item {\n  display:flex;\n  align-items: normal;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
